export default __webpack_public_path__ + "static/media/franchises-icon3.be2e2bb9.svg";